export enum CloudDriveProvider {
    Cloud = 0,
    Dropbox = 1,
    OneDrive = 2
}
